<input
  type="file"
  class="file-input"
  [accept]="acceptedFileTypes"
  (change)="onFileSelected($event)"
  #fileUpload
/>

<div
  *ngIf="fileError"
  class="alert alert-danger mt-2"
>
  {{ fileError }}
</div>

<div class="row file-upload text-dark text-small">
  <div class="col-sm-10 col-9 text-left">
    <span *ngFor="let file of fileName">
      <span class="row alert alert-secondary alert-dismissible special">
        <a href="#" class="close" data-dismiss="alert" aria-label="close"
          >&times;</a
        >
        <strong> {{ file }}</strong>
      </span>
    </span>
  </div>
  <div class="col-sm-2 col-3 text-right mt-2 mb-2">
    <button
      color="primary"
      class="btn btn-secondary"
      (click)="fileUpload.click()"
    >
      <i
        *ngIf="isLoading == false"
        class="fa fa-paperclip"
        aria-hidden="true"
      ></i>
      <i
        *ngIf="isLoading == true"
        class="fa fa-spinner fa-spin"
        aria-hidden="true"
      ></i>
    </button>
  </div>
</div>

<div class="progress" *ngIf="uploadProgress">
  <mat-progress-bar
    class="progress-bar"
    mode="determinate"
    [value]="uploadProgress"
  >
  </mat-progress-bar>

  <button class="btn btn-primary" type="button" (click)="cancelUpload()">
    <i class="fa fa-delete" aria-hidden="true"></i>
  </button>
</div>
